import * as angular from 'angular';
import ModalFactory from './modal.factory';
import modalComponent from './modal.component';
import modalCloseComponent from './modal-close/modal-close.component';
import ModalZoomImageController from './modal-zoom-image/modal-zoom-image.controller';
import ModalTermsConditionsController from './modal-terms-conditions/modal-terms-conditions.controller';
import ModalIframeController from './modal-iframe/modal.iframe.controller';

require('angular-modal-service');

export default angular
  .module('ModalModule', [
    'angularModalService',
  ])
  .component('modal', modalComponent)
  .component('modalClose', modalCloseComponent)
  .controller('ModalZoomImageController', ModalZoomImageController)
  .controller('ModalTermsConditionsController', ModalTermsConditionsController)
  .controller('ModalIframeController', ModalIframeController)
  .factory('ModalFactory', ModalFactory)
  .name;



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal.module.js